import { gql } from '@apollo/client';
import { client } from 'graphql/client';

export const SET_DRIVER_BLACKLIST = gql`
    mutation SetDriverBlacklist($input: SetDriverBlacklistInput!) {
        setDriverBlacklist(input: $input) {
            success
            message
        }
    }
`;

export interface SetDriverBlacklistInput {
    phones: number[];
    isBlacklist: boolean;
    banReason: number;
    banType: number;
    banPeriod?: number | null;
}

export interface SetDriverBlacklistResult {
    success: boolean;
    message: string;
}

export interface SetDriverBlacklistResponse {
    setDriverBlacklist: SetDriverBlacklistResult;
}

export interface SetDriverBlacklistVariables {
    input: SetDriverBlacklistInput;
}

export const setDriverBlacklist = async (input: SetDriverBlacklistInput): Promise<SetDriverBlacklistResult> => {
    const { data } = await client.mutate<SetDriverBlacklistResponse, SetDriverBlacklistVariables>({
        mutation: SET_DRIVER_BLACKLIST,
        variables: { input },
    });
    return data!.setDriverBlacklist;
};
